/**
 * ARES lookup pro wizard Nova zakazka (BLOK 5). Vzor prevzat z
 * `/opt/brewery-os/packages/core/src/billing/vatReliability.ts`
 * (docs/platform/ui/MAPY-ARES-PREVZETI.md §4): primy REST dotaz, 404 =
 * nenalezeno, zadny klic.
 *
 * ROZHODNUTI (BLOK 5): volani je klientske (jako v puvodnim RedHandForm),
 * ne serverove — REOS zatim nema API endpoint pro koncepty zakazek (jsou
 * jen v pameti pruvodce, viz lib/wizard-model.ts). Az vznikne backend pro klienty,
 * tohle se presune za server (MAPY-ARES-PREVZETI.md pozaduje serverove
 * volani pro produkcni REOS s evidenci a telemetrii).
 */

export interface AresResult {
  readonly obchodniJmeno: string;
  readonly sidloTextovaAdresa: string;
}

interface AresApiResponse {
  readonly obchodniJmeno?: string;
  readonly sidlo?: { readonly textovaAdresa?: string };
}

const ARES_BASE = 'https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty';

export function isValidIco(ico: string): boolean {
  return /^\d{8}$/.test(ico.trim());
}

export type AresLookupOutcome =
  | { readonly status: 'FOUND'; readonly result: AresResult }
  | { readonly status: 'NOT_FOUND' }
  | { readonly status: 'ERROR' };

export async function lookupAres(ico: string): Promise<AresLookupOutcome> {
  try {
    const res = await fetch(`${ARES_BASE}/${encodeURIComponent(ico)}`, { signal: AbortSignal.timeout(8000) });
    if (res.status === 404) return { status: 'NOT_FOUND' };
    if (!res.ok) return { status: 'ERROR' };
    const data = (await res.json()) as AresApiResponse;
    if (data.obchodniJmeno === undefined) return { status: 'NOT_FOUND' };
    return {
      status: 'FOUND',
      result: { obchodniJmeno: data.obchodniJmeno, sidloTextovaAdresa: data.sidlo?.textovaAdresa ?? '' },
    };
  } catch {
    return { status: 'ERROR' };
  }
}
